import { WebsocketWrapper } from '@missionlabs/smartagent-lib-shared';
import AnyAction from 'store/anyActions';

import WebSocketTypes from './websocket.types';
import WebsocketState from './websocket.state';
import { addBaseListeners } from './websocket.utils';

export default function (state: WebsocketState = null, action: AnyAction): WebsocketState {
    switch (action.type) {
        case WebSocketTypes.CREATE_WEBSOCKET_CONNECTION:
            let websocket: WebsocketState = null;
            try {
                websocket = new WebsocketWrapper(action.payload);
                addBaseListeners(websocket);
            } catch (error) {
                console.error(error);
            }

            return websocket;
        default:
            return state;
    }
}
